import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getInProgressItemsTotalPrice, getInProgressItemsTotalSavings, isZeroMonetaryValue } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../../context/occ/hooks/use-i18n';
import { Button } from '../../button/button';
import { ButtonColor } from '../../button/types/color';
import { ButtonSize } from '../../button/types/size';
import { ItemModalQuantityInput } from './quantity-input';
const b = bemClassBuilder('v-item-modal-footer');
export const ItemModalFooter = observer(props => {
    const i18n = useI18n();
    const { displayText, assets, isNormalItem, onAddToCart, quantityInputProps } = props;
    const totalPrice = getInProgressItemsTotalPrice();
    const totalSavings = getInProgressItemsTotalSavings();
    return (_jsxs(_Fragment, { children: [isNormalItem && (_jsxs("div", Object.assign({ className: b.element('quantity') }, { children: [_jsx("span", Object.assign({ className: b.element('quantity-label') }, { children: displayText.quantityCounterLabel })), _jsx(ItemModalQuantityInput, Object.assign({}, quantityInputProps))] }))), _jsxs("div", Object.assign({ className: b.element('action-button-details') }, { children: [_jsx(Button, { className: b.element('action-button'), color: ButtonColor.Primary, label: getFormattedButtonLabel(totalPrice, displayText.addToOrderButtonLabel, i18n), size: ButtonSize.Large, iconName: assets.addItemButtonIconName, onClick: onAddToCart }), !isZeroMonetaryValue(totalSavings) && (_jsx("span", Object.assign({ className: b.element('savings-label') }, { children: getFormattedTotalSavingsLabel(totalSavings, displayText.totalSavingsLabel, i18n) })))] }))] }));
});
ItemModalFooter.displayName = 'ItemModalFooter';
const getFormattedButtonLabel = (total, template, i18n) => {
    return i18n.template(template, {
        total: i18n.monetaryValue(total)
    });
};
const getFormattedTotalSavingsLabel = (total, template, i18n) => {
    return i18n.template(template, {
        total: i18n.monetaryValue(total)
    });
};
